import classNames from 'classnames';

import css from './link-button.css';

import type { LinkButtonVariants } from './link-button.css';
import type { PropsWithChildren } from 'react';

export interface LinkButtonProps {
  href: string;
  target?: HTMLAnchorElement['target'];
  title?: string;
  disabled?: boolean;
  variants?: Omit<LinkButtonVariants, 'disabled'>;
  className?: string;
}

export const LinkButton = ({
  href,
  target,
  title,
  children,
  disabled,
  variants,
  className
}: PropsWithChildren<LinkButtonProps>) => {
  return (
    <a
      href={href}
      target={target}
      title={title}
      className={classNames(css.linkButton({ disabled, ...variants }), className)}
    >
      {children}
    </a>
  );
};
